import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { SHARE_LINKS_KEY } from '~/queries/keys';
import shareLinkApi from '~/shareLinkApi';
import { mapShareLinkFromApiToVm } from '~/shareLinkApi/shareLink.mappers';
import { IShareLinkMapped } from '~/shareLinkApi/shareLink.model';

export const useGetShareLink = ({ sharedToken }: { sharedToken: string }) => {
  return useQuery<AxiosResponse, AxiosError, IShareLinkMapped, any>({
    queryKey: [SHARE_LINKS_KEY, { sharedToken }],
    queryFn: async () => {
      return shareLinkApi
        .get(`share-links/${sharedToken}`)
        .then(({ data }) => mapShareLinkFromApiToVm(data));
    },
    enabled: Boolean(sharedToken),
  });
};
